<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
// import { mapActions, mapState } from 'vuex';

export default {
  name: 'VeiculoMain',
  created() {
    // this.show();
  },
  destroyed() {
    // this.reset();
  },
  computed: {
    // ...mapState('configuracao', ['config']),
  },
  methods: {
    // ...mapActions('configuracao', ['show', 'reset']),
  },
};
</script>
